var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}],attrs:{"color":_vm.isTransparent ? 'transparent' : '#F5F5F5',"app":"","flat":""}},[_c('v-spacer'),_c('SocialMedia')],1)}
var staticRenderFns = []

export { render, staticRenderFns }